var map = {
	"./Blog": "eERc",
	"./Blog.vue": "eERc",
	"./Home": "OeKf",
	"./Home.vue": "OeKf",
	"./HomeGoogle": "RvuX",
	"./HomeGoogle.vue": "RvuX",
	"./HomeNewGoogle": "lf4T",
	"./HomeNewGoogle.vue": "lf4T",
	"./Page": "vk1k",
	"./Page.vue": "vk1k",
	"./PasswordRecover": "HYM/",
	"./PasswordRecover.vue": "HYM/",
	"./widgets/Announce": "0NE1",
	"./widgets/Announce.vue": "0NE1",
	"./widgets/Footer": "rvOX",
	"./widgets/Footer.vue": "rvOX",
	"./widgets/GoogleFooter": "GiuV",
	"./widgets/GoogleFooter.vue": "GiuV",
	"./widgets/Lang": "LbQz",
	"./widgets/Lang.vue": "LbQz",
	"./widgets/Login": "o2co",
	"./widgets/Login.vue": "o2co"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5mI6";